@if (facilitiesLoaded) {
  <mat-form-field appearance="fill">
    <mat-label>
      @if (selectedFacilitiesCount > 1) {
        Stores Selected ({{ selectedFacilitiesCount }})
      }
      @if (selectedFacilitiesCount <= 1) {
        Select an option
      }
    </mat-label>
    <mat-select [formControl]="selectedFacilities" multiple (selectionChange)="storeSelected()">
      @for (facility of facilities; track facility) {
        <mat-option
          [value]="facility.facilityId.toString()"
          [disabled]="facility.facilityId.toString() === currentFacilityId">
          {{ facility.facilityId }} - {{ facility.facilityName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <div>
    <h4>Stores Selected ({{ selectedFacilitiesCount }})</h4>
    <ul class="selected-store-list">
      @for (facility of facilities; track facility.facilityId) {
        @if (selectedFacilities.value?.includes(facility.facilityId.toString())) {
          <li>
            {{ facility.facilityId }} - {{ facility.facilityName }}
            @if (facility.facilityId.toString() === currentFacilityId) {
              (Current Store)
            }
          </li>
        }
      }
    </ul>
  </div>
}
@if (!facilitiesLoaded) {
  <div class="spinner-box">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
}
